<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="300" persistent>
      <v-card>
        <v-card-title :class="['text-h5', `${color} darken-3`, 'white--text']">
          {{ title }}
        </v-card-title>

        <v-card-text>
          <div class="row mt-2">

            <div class="col-12">
              <v-file-input v-model="xarchivo" :accept="accept" dense outlined label="Archivo"
                placeholder="Seleccione el archivo..." />
            </div>
          </div>
          <v-progress-linear v-if="loading" class="mt-2" indeterminate />
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" :disabled="loading" outlined @click="enviar()"> Enviar </v-btn>
          <v-btn color="red" outlined @click="cerrar()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import xaxios from '@/xaxios';
export default {
  props: {
    uploadUrl: { type: String, required: true },
    color:{type: String, default: 'red'},
    title: { type: String, default: 'Subir archivo Excel' },
    accept: { type: String, default: '.xlsx' },


  },
  data() {
    return {
      loading: true,
      dialog: false,
      meses: [],
      gestiones: [],
      xarchivo: null,
      input: { mes: null, gestion: null, nit: {} },
    };
  },
  methods: {
    async openmodal(xproy, meses, gestiones) {
      this.input = xproy;
      this.meses = meses;
      this.gestiones = gestiones;
      this.xarchivo = null;
      this.loading = false;
      this.dialog = true;
    },
    cerrar() {
      this.dialog = false;
    },
    getToken(){
      let s = window.localStorage.getItem('TOKEN');
      let decryptedBytes = window.CryptoJS.AES.decrypt(s, 'estanoesunaclavesecreta');
      return decryptedBytes.toString(window.CryptoJS.enc.Utf8);

    },
    async enviar() {
      window.console.log("url ffff",this.uploadUrl)
      if (!this.xarchivo) {
        this.$root.$notify.show('Debe seleccionar un archivo', { color: 'orange' });
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", this.xarchivo);
      formData.append("mes", this.input.mes);
      formData.append("anio", this.input.gestion);
      
      let accessToken = this.getToken();
      //let url = process.env.VUE_APP_API_REST + `/api/v1/esam/`+this.uploadUrl;
      let config = {
        method: 'POST',
        url: this.uploadUrl,
        data: formData,
        headers: { 'Content-Type': 'application/json', Authorization: accessToken },
      };
      let res = await xaxios.request(config).then(data => data).catch(error => error);
      window.console.log('res----->', res);
      if (res && res.data) {
        this.$root.$notify.show(res.data, { color: 'green', x: 'right', });
        this.$emit('cargado')
        this.dialog = false;
      }

      this.loading = false;
    }
  },
};
</script>
